package floris.graphics.backoffice.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignSelf
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import floris.graphics.backoffice.components.layouts.logout
import floris.graphics.core.constants.Res
import floris.graphics.core.navigation.Navigation
import com.materialdesignsystem.components.sections.BaseHeader
import com.materialdesignsystem.components.sections.NavigationItem
import com.materialdesignsystem.components.svg.overflowMenuSvg
import com.materialdesignsystem.constants.Constants
import com.materialdesignsystem.toColorScheme
import org.jetbrains.compose.web.css.AlignSelf
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh

@Composable
fun SidePanel() {
    val ctx = rememberPageContext()

    Column(
        modifier = Modifier
            .padding(top = 50.px, leftRight = 40.px)
            .fillMaxWidth(30.percent)
            .maxWidth(Constants.SIDE_PANEL_WIDTH.px)
            .height(100.vh) // full screen height
            .position(Position.Sticky)
            .top(0.px)
            .backgroundColor(ColorMode.current.toColorScheme.secondaryContainer)
            .zIndex(9)
            .alignSelf(AlignSelf.Start)
    ) {
        Image(
            modifier = Modifier
                .height(Constants.HEADER_COLLAPSED_LOGO_HEIGHT.px)
                .maxWidth(250.px)
                .fillMaxWidth()
                .margin(bottom = 60.px)
                .cursor(Cursor.Pointer)
                .onClick {
                    ctx.router.navigateTo(Navigation.Screen.Admin.Home.route)
                },
            src = Res.Image.logo,
            alt = "Logo Image"
        )

        NavigationItems()
    }
}

@Composable
fun NavigationItems() {
    val context = rememberPageContext()

    SpanText(
        modifier = Modifier
            .fontSize(14.px)
            .color(ColorMode.current.toColorScheme.onSecondaryContainer)
            .margin(bottom = 30.px),
        text = "Dashboard"
    )

    NavigationItem(
        modifier = Modifier.margin(bottom = 24.px),
        selected = context.route.path == Navigation.Screen.Admin.Home.route,
        title = "Home",
        icon = "home",
        href = Navigation.Screen.Admin.Home.route
    )

    NavigationItem(
        modifier = Modifier.margin(bottom = 24.px),
        selected = context.route.path.contains(Navigation.Screen.Admin.Categories.Index.route),
        title = "Categories",
        icon = "interests",
        href = Navigation.Screen.Admin.Categories.Index.route
    )

    NavigationItem(
        modifier = Modifier.margin(bottom = 24.px),
        selected = context.route.path.contains(Navigation.Screen.Admin.Techstacks.Index.route),
        title = "Techstacks",
        icon = "handyman",
        href = Navigation.Screen.Admin.Techstacks.Index.route
    )

    NavigationItem(
        modifier = Modifier.margin(bottom = 24.px),
        title = "Contributors",
        selected = context.route.path.contains(Navigation.Screen.Admin.Contributors.Index.route),
        icon = "article_person",
        href = Navigation.Screen.Admin.Contributors.Index.route
    )

    NavigationItem(
        modifier = Modifier.margin(bottom = 24.px),
        title = "Projects",
        selected = context.route.path.contains(Navigation.Screen.Admin.Projects.Index.route),
        icon = "view_kanban",
        href = Navigation.Screen.Admin.Projects.Index.route
    )

    NavigationItem(
        modifier = Modifier.margin(bottom = 24.px),
        title = "Settings",
        selected = context.route.path.contains(Navigation.Screen.Admin.Settings.route),
        icon = "settings",
        href = Navigation.Screen.Admin.Settings.route
    )

    NavigationItem(
        modifier = Modifier.margin(top = 75.px),
        title = "Logout",
        icon = "logout",
        href = Navigation.Screen.Admin.Login.route,
        onClick = {
            logout()
        }
    )
}

@Composable
fun Header(
    onMenuClick: () -> Unit
) {
    val ctx = rememberPageContext()

    BaseHeader(
        backgroundColor = ColorMode.current.toColorScheme.secondaryContainer
    ) {
        Row(
            modifier = Modifier
                .margin(left = 24.px)
                .fillMaxWidth()
        ) {
            overflowMenuSvg(
                modifier = Modifier
                    .margin(right = 24.px)
                    .cursor(Cursor.Pointer)
                    .onClick {
                        onMenuClick()
                    },
                fill = ColorMode.current.toColorScheme.onSecondaryContainer
            )

            Image(
                modifier = Modifier
                    .height(Constants.HEADER_COLLAPSED_LOGO_HEIGHT.px)
                    .cursor(Cursor.Pointer)
                    .onClick {
                        ctx.router.navigateTo(Navigation.Screen.Admin.Home.route)
                    },
                src = Res.Image.logo,
                alt = "Logo Image"
            )
        }
    }
}
